import React, { useState, useMemo, useEffect } from "react";
import { Col, DatePicker, Form, Input, Row, Spin, Table } from "antd";
import styled from "styled-components";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { uniqBy } from "lodash";
import {
  getAllDepartmentList,
  getClientid,
  getLocations,
  getUserList,
} from "redux/selectors";
import { useSelector } from "react-redux";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import dayjs from "dayjs";

const StyledHrWrapper = styled.div`
  .total_weeks_logged {
    width: 12%;
    font-size: 16px;
    font-weight: 400;
    margin-top: -15px;
  }
  .top_filters_container {
    width: 88%;
    // gap: 6px;
  }
  .input_field {
    width: 96%;
    border-radius: 24px;
  }

  .input_field.ant-btn {
    // width: 150px !important;
    width: 96% !important;
    border-radius: 24px;
  }

  .ant-btn {
    width: 96% !important;
    border-radius: 24px;
  }

  .ant-select {
    // width: 150px !important;
    width: 96%;

    .ant-select-selector {
      border-radius: 24px;
    }
  }

  .ant-table-wrapper {
    @media (max-width: 768px) {
      .ant-table {
        font-size: 12px;
      }

      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        padding: 8px 4px;
        white-space: nowrap;
      }

      .ant-table-thead > tr > th {
        font-size: 11px;
        font-weight: 600;
      }
    }

    @media (max-width: 480px) {
      .ant-table {
        font-size: 11px;
      }

      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        padding: 6px 2px;
      }
    }
  }

  .ant-picker .ant-picker-input > input::placeholder {
    color: black;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 320px) and (max-width: 1060px) {
    flex-direction: column;
    align-items: start;
    gap: 8px;

    .top_filters_container {
      width: 100%;
      gap: 8px;
    }
    .total_weeks_logged {
      width: 100%;
    }

    .input_field {
      width: 100%;
      border-radius: 24px;
    }

    .input_field.ant-btn {
      width: 100% !important;
      border-radius: 24px;
    }

    .ant-btn {
      width: 100% !important;
      border-radius: 24px;
    }

    .ant-select {
      width: 100% !important;

      .ant-select-selector {
        border-radius: 24px;
      }
    }
  }
`;

function getWeeksForMonth(year, monthZeroBased) {
  const ordinal = (n) => {
    const v = n % 100;
    if (v >= 11 && v <= 13) return `${n}th`;
    switch (n % 10) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  };

  const firstDay = new Date(year, monthZeroBased, 1);
  const lastDay = new Date(year, monthZeroBased + 1, 0);

  const firstDayWeekday = firstDay.getDay();
  const diffToMonday = firstDayWeekday === 0 ? -6 : 1 - firstDayWeekday;
  const firstMonday = new Date(firstDay);
  firstMonday.setDate(firstDay.getDate() + diffToMonday);

  const lastDayWeekday = lastDay.getDay();
  const diffToSunday = lastDayWeekday === 0 ? 0 : 7 - lastDayWeekday;
  const lastSunday = new Date(lastDay);
  lastSunday.setDate(lastDay.getDate() + diffToSunday);

  const weeks = [];
  let weekStart = new Date(firstMonday);

  while (weekStart <= lastSunday) {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    if (weekEnd < firstDay || weekStart > lastDay) {
      weekStart.setDate(weekStart.getDate() + 7);
      continue;
    }

    const getISOWeek = (date) => {
      const tmp = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
      );
      const dayNum = tmp.getUTCDay() || 7; // Monday=1, Sunday=7
      tmp.setUTCDate(tmp.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
      const weekNo = Math.ceil(((tmp - yearStart) / 86400000 + 1) / 7);
      return `${tmp.getUTCFullYear()}-W${weekNo.toString().padStart(2, "0")}`;
    };

    const label = `${ordinal(weekStart.getDate())} - ${ordinal(
      weekEnd.getDate()
    )}`;
    const value = getISOWeek(weekStart); // value as ISO week

    weeks.push({ label, value });

    weekStart.setDate(weekStart.getDate() + 7);
  }

  return weeks;
}

// Example

const weekFormat = (value) => {
  const startOfWeek = dayjs(value).startOf("isoWeek").format("Do MMM");
  const endOfWeek = dayjs(value).endOf("isoWeek").format("Do MMM YYYY");
  return `${startOfWeek} - ${endOfWeek}`;
};

const HrTab = ({
  setLogDetails,
  setIsAddEdit,
  filteredList,
  setFilteredList,
  tabId,
  setIsHRTab,
}) => {
  console.log("filterdList-->", filteredList);
  const ClientId = useSelector(getClientid);
  const [employeeFilterList, setEmployeeFilterList] = useState([]);
  const AllDepartmentList = useSelector(getAllDepartmentList);
  const locationList = useSelector(getLocations);
  const [form] = Form.useForm();
  const [searchTerm, setSearchTerm] = useState("");
  const [weekOptions, setWeekOptions] = useState([]);
  const [selectedWeeks, setSelectedWeeks] = useState([
    `${dayjs().isoWeekYear()}-W${dayjs().isoWeek()}`,
  ]);
  console.log("selectedweek", selectedWeeks);
  console.log("weekOptions-->", weekOptions);
  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  console.log("slectedMonth3-->", selectedMonth);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const userLists = useSelector(getUserList);
  const [logList, setLogList] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("logList2-->", logList);

  const ProductLogGet = async (status) => {
    try {
      const now = dayjs();
      const year = now.year();
      const monthZeroBased = now.month();

      const weeks = getWeeksForMonth(year, monthZeroBased);
      const weekLabels = weeks.map((week) => week.value);
      setLoading(true);
      const { statusCode, response } = await CALL_API(
        `productLogGet/${ClientId}`,
        "post",
        { week: selectedWeeks || [""] }
      );

      if (statusCode === STATUS_CODE.SUCCESS) {
        setLogList(
          response
            // ?.filter((val) => val?.status !== "draft")
            ?.sort(
              (a, b) => new Date(b.selected_date) - new Date(a.selected_date)
            )
            ?.map((val) => {
              const finduser = userList.find(
                (item) => item?.userid === val?.userid
              );
              return {
                ...val,
                // type: val?.status,
                basedepartmentid: finduser?.basedepartmentid,
                baselocationid: finduser?.baselocationid,
              };
            })
        );
      }
    } catch (error) {
      console.error("Error fetching product logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const initialData = [
    {
      key: "1",
      name: "William Bern",
      employee_id: "EM1234",
      week: "8th Feb - 14th Feb 2024",
      submitted_on: "15th Feb 2024",
      products: 4,
      days_worked: 5,
      total_hours: 48,
    },
    {
      key: "2",
      name: "James",
      employee_id: "EM1234",
      week: "8th Feb - 14th Feb 2024",
      submitted_on: "15th Feb 2024",
      products: 4,
      days_worked: 5,
      total_hours: 48,
    },
    {
      key: "3",
      name: "Smitha",
      employee_id: "EM1234",
      week: "8th Feb - 14th Feb 2024",
      submitted_on: "15th Feb 2024",
      products: 4,
      days_worked: 5,
      total_hours: 48,
    },
    {
      key: "4",
      name: "Albert",
      employee_id: "EM1234",
      week: "8th Feb - 14th Feb 2024",
      submitted_on: "15th Feb 2024",
      products: 4,
      days_worked: 5,
      total_hours: 48,
    },
  ];

  const filteredData = useMemo(() => {
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return initialData;
    return initialData.filter((row) =>
      String(row.name || "")
        .toLowerCase()
        .includes(q)
    );
  }, [initialData, searchTerm]);

  const columns = [
    {
      title: "Name",
      dataIndex: "userid",
      key: "userid",
      width: 100,
      render: (text) => {
        return userList?.find((val) => val?.userid === text)?.fullname || "-";
      },
    },
    {
      title: "Employee ID",
      dataIndex: "userid",
      key: "userid",
      width: 120,
      render: (text) => {
        return userList?.find((val) => val?.userid === text)?.employeeid || "-";
      },
    },
    {
      title: "Week",
      dataIndex: "selected_date",
      key: "selected_date",
      width: 180,
      render: (text) => {
        return weekFormat(text) || "-";
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 130,
      render: (text) => {
        return text === "draft"
          ? "Draft"
          : text === "submit"
          ? "Submitted"
          : "-";
      },
    },
    {
      title: "Submitted on",
      dataIndex: "submitedon",
      key: "submitedon",
      width: 130,
      render: (text, record) => {
        return dayjs(text)?.isValid() && record?.status !== "draft"
          ? dayjs(text)?.format("Do MMM YYYY")
          : "-";
      },
    },
    {
      title: "Products",
      dataIndex: "productcount",
      key: "productcount",
      align: "center",
      width: 100,
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Days Worked",
      dataIndex: "daysworked",
      key: "daysworked",
      align: "center",
      width: 120,
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Total Hours",
      dataIndex: "totalhours",
      key: "totalhours",
      align: "center",
      width: 120,
      render: (text) => {
        return (
          Number(text || 0)
            .toFixed(2)
            .replace(/\.00$/, "")
            .replace(/(\.\d)0$/, "$1") || "-"
        );
      },
    },
  ];

  const TypeOptions = [
    { label: "Full time", value: "full_time" },
    { label: "Part time", value: "part_time" },
    { label: "Contract", value: "contract" },
    { label: "Paid Internship", value: "paid_internship" },
    { label: "Unpaid Internship", value: "unpaid_internship" },
    { label: "Training", value: "training" },
    { label: "Probation", value: "probation" },
    { label: "Casual", value: "casual" },
  ];

  const userList = useMemo(
    () => userLists?.filter((user) => user?.statusid === "1"),
    [userLists]
  );

  const uniqueDepartmentName = uniqBy(
    AllDepartmentList?.map((item) => {
      return {
        label: item?.department_name,
        value: item?.department_id,
      };
    }),
    "value"
  );

  const uniqueLocationName = uniqBy(
    locationList
      ?.filter((val) => val?.login_from_anywhere !== 1)
      .map((item) => {
        return {
          label: item?.location_name,
          value: item?.location_id,
        };
      }),
    "value"
  );

  const convertWeeksToDateRange = (weeks) => {
    return weeks.map((weekStr) => {
      const [yearStr, weekNumStr] = weekStr.split("-W");
      const year = parseInt(yearStr, 10);
      const weekNum = parseInt(weekNumStr, 10);

      // Day.js ISO week starts on Monday
      const startDay = dayjs().year(year).isoWeek(weekNum).startOf("isoWeek");
      const endDay = startDay.endOf("isoWeek");

      return `${startDay.toISOString()}|${endDay.toISOString()}`;
    });
  };
  const handleWeeksChange = (checkedValues) => {
    console.log("selected weeks-->", checkedValues);
    let weekLabels = [];

    weekLabels = checkedValues;

    setSelectedWeeks(weekLabels);
  };

  const handleFormChange = (changedValues, allValues) => {
    console.log("changedValues:", changedValues);
    console.log("allValues:", allValues);

    // only update weeks if the weeks field actually changed
    if (
      changedValues &&
      Object.prototype.hasOwnProperty.call(changedValues, "weeks")
    ) {
      handleWeeksChange(changedValues?.weeks);
    }

    const peopleSelect = allValues?.people || [];
    const depSelected = allValues?.department || [];
    const locSelected = allValues?.location || [];
    const typeSelect = allValues?.type || [];

    // other filters
    if (
      !depSelected?.length &&
      !locSelected?.length &&
      !peopleSelect?.length &&
      !typeSelect?.length
    ) {
      setFilteredList(logList);
      return;
    }

    const normalize = (val) => {
      if (val == null) return [];
      if (Array.isArray(val)) return val.map(String);
      if (typeof val === "object") {
        return Object.values(val).flat().map(String).filter(Boolean);
      }
      return [String(val)];
    };

    const logFilter = (logList || []).filter((user) => {
      const userDepts = normalize(user?.basedepartmentid);
      const userLocs = normalize(user?.baselocationid);
      const users = normalize(user?.userid);
      const types = normalize(user?.status);
      console.log("types-->", types);

      const peopleMatch =
        !peopleSelect.length ||
        peopleSelect.some((sel) => users?.includes(String(sel)));

      const departmentMatch =
        !depSelected.length ||
        depSelected.some((sel) => userDepts.includes(String(sel)));

      const locationMatch =
        !locSelected.length ||
        locSelected.some((sel) => userLocs.includes(String(sel)));

      const typeMatch =
        !typeSelect.length ||
        typeSelect.some((sel) => types?.includes(String(sel)));

      return peopleMatch && typeMatch && departmentMatch && locationMatch;
    });

    setFilteredList(logFilter);
  };

  const handleMonthChange = (dateMoment, dateString) => {
    setSelectedMonth(dateString);
    if (!dateMoment) {
      setWeekOptions([]);
      setSelectedWeeks([]);
      form.setFieldsValue({ weeks: [] });
      return;
    }
    const year = dateMoment.year();
    const monthZeroBased = dateMoment.month();
    const weeks = getWeeksForMonth(year, monthZeroBased);
    setWeekOptions(weeks);

    // Use week.value directly, it's already "YYYY-Www"
    const weekLabels = weeks.map((week) => week.value);

    setSelectedWeeks(weekLabels);
    form.setFieldsValue({ weeks: weekLabels });
  };

  useEffect(() => {
    if (tabId !== "2") return;
    // Avoid calling ProductLogGet when selectedWeeks is not set or empty.
    if (
      !selectedWeeks ||
      (Array.isArray(selectedWeeks) && selectedWeeks.length === 0)
    ) {
      return;
    }
    setLoading(true);
    const timer = setTimeout(() => {
      ProductLogGet();
    }, 500); // delay in ms

    return () => clearTimeout(timer); // cleanup on unmount or dependency change
  }, [selectedWeeks, tabId]);

  useEffect(() => {
    setFilteredList(logList);
  }, [logList, userList, tabId]);

  useEffect(() => {
    if (selectedMonth) {
      const dateMoment = dayjs(selectedMonth, "MMMM YYYY");
      handleMonthChange(dateMoment, selectedMonth);
    }
  }, [selectedMonth, tabId]);

  return (
    <>
      <StyledHrWrapper>
        <Form
          form={form}
          onValuesChange={handleFormChange}
          initialValues={{
            people: selectedPeople,
            type: selectedType,
            department: selectedDepartment,
            location: selectedLocation,
            week: selectedWeeks,
          }}
        >
          <HeaderRow>
            <div className="total_weeks_logged">
              Total Logs: {filteredList?.length || 0}
            </div>
            <Row className="top_filters_container">
              <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                <DropdownCheckBox
                  name="people"
                  label="Search People"
                  options={uniqBy(
                    filteredList.map((item) => {
                      return {
                        label: userList?.find(
                          (val) => val?.userid === item?.userid
                        )?.fullname,
                        value: item?.userid,
                      };
                    }),
                    "value"
                  )}
                  form={form}
                  handleFormChange={handleFormChange}
                  value={selectedPeople}
                  onChange={setSelectedPeople}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                <DropdownCheckBox
                  name="type"
                  label="Status"
                  options={[
                    { label: "Draft", value: "draft" },
                    { label: "Submited", value: "submit" },
                  ]?.map((item) => {
                    return { label: item?.label, value: item?.value };
                  })}
                  className="input_field"
                  customStyle={true}
                  form={form}
                  handleFormChange={handleFormChange}
                  value={selectedType}
                  onChange={setSelectedType}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                <DropdownCheckBox
                  name="department"
                  label="Department"
                  options={uniqueDepartmentName}
                  form={form}
                  customStyle={true}
                  handleFormChange={handleFormChange}
                  value={selectedDepartment}
                  onChange={setSelectedDepartment}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                <DropdownCheckBox
                  name="location"
                  label="Location"
                  options={uniqueLocationName}
                  form={form}
                  customStyle={true}
                  handleFormChange={handleFormChange}
                  value={selectedLocation}
                  onChange={setSelectedLocation}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                <DatePicker
                  allowClear={false}
                  className="input_field"
                  onChange={handleMonthChange}
                  picker="month"
                  format="MMMM YYYY"
                  value={
                    dayjs(selectedMonth, "MMMM YYYY")
                      ? dayjs(selectedMonth, "MMMM YYYY")
                      : selectedMonth || dayjs()
                  }
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                <DropdownCheckBox
                  name="weeks"
                  label="Select Week"
                  options={weekOptions}
                  value={selectedWeeks}
                  className="input_field"
                  customStyle={true}
                  disabled={selectedMonth === "" || selectedMonth === null}
                  form={form}
                  handleFormChange={handleFormChange}
                  onChange={setSelectedWeeks}
                />
              </Col>
            </Row>
          </HeaderRow>
        </Form>
        <div
          className="w-100 text-end"
          style={{ color: "#2D53DA", cursor: "pointer" }}
          onClick={() => {
            form.resetFields();
            setSelectedMonth(dayjs());
          }}
        >
          Clear All
        </div>
        <Spin spinning={loading}>
          <Table
            dataSource={filteredList || []}
            columns={columns}
            scroll={{
              x: "max-content",
              y: 400,
            }}
            onRow={(record) => ({
              onClick: (e) => {
                e.stopPropagation();
                setLogDetails(record);
                setIsHRTab(true);
                setIsAddEdit(true);
              },
              className: "hover-row",
            })}
            pagination={false}
          />
        </Spin>
      </StyledHrWrapper>
    </>
  );
};

export default HrTab;
